export default __webpack_public_path__ + "static/ai-solutions-with-roadmap4--mobile-879ca92aabd1a453ee6010f27b67331d.jpg";